import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import "./stock-report.css";
import { getFamily } from "../Redux/Actions/IngredientActions";

const StockReport = () => {
  const dispatch = useDispatch();
  const [stockData, setStockData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [locations, setLocations] = useState([]);
  const [filters, setFilters] = useState({
    location: "",
    ingredient: "",
    search: ""
  });
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState("");
  
  const familiesData = useSelector((state) => state.IngredientReducer?.families || []);
  const user = useSelector((state) => state.auth?.user);

  useEffect(() => {
    const fetchStockData = async () => {
      try {
        const response = await axios.get("/api/Invoices/stock-report");
        console.log("Données reçues:", response.data);
        setStockData(response.data);
        setFilteredData(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Erreur récupération stock:", error);
        setLoading(false);
      }
    };

    const fetchLocations = async () => {
      try {
        const response = await axios.get("/api/Locationspin/getAllLocations");
        let locationsData = response.data;
        
        if (Array.isArray(locationsData)) {
          setLocations(locationsData);
        } else if (locationsData && locationsData.locations) {
          setLocations(locationsData.locations);
        } else if (locationsData && locationsData.data) {
          setLocations(locationsData.data);
        }
      } catch (error) {
        console.error("Erreur chargement localisations:", error);
      }
    };

    fetchStockData();
    fetchLocations();
  }, []);

  useEffect(() => {
    if (familiesData.length === 0) {
      dispatch(getFamily());
    }
  }, [familiesData, dispatch]);

  // Fonction pour mettre à jour le stock de sécurité
  const updateSafetyStock = async (ingredientId, locationId, stockItemId, newValue) => {
    try {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      
      if (!token) {
        alert("Session expirée. Veuillez vous reconnecter.");
        return;
      }

      const numericValue = parseFloat(newValue);
      if (isNaN(numericValue) || numericValue < 0) {
        alert("Veuillez saisir un nombre valide supérieur ou égal à 0");
        return;
      }

      await axios.put("/api/stock/update-safety-stock", {
        ingredient: ingredientId,
        localisation: locationId,
        safetyStock: numericValue
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      // Mettre à jour localement
      setStockData(prev => prev.map(item => {
        if (item._id === stockItemId) {
          return { ...item, safetyStock: numericValue };
        }
        return item;
      }));
      
      setFilteredData(prev => prev.map(item => {
        if (item._id === stockItemId) {
          return { ...item, safetyStock: numericValue };
        }
        return item;
      }));
      
      setEditingId(null);
      setEditValue("");
      
      alert("✓ Stock de sécurité mis à jour");
      
    } catch (error) {
      console.error("Erreur:", error);
      alert("Erreur lors de la mise à jour");
    }
  };

  // FONCTION CORRIGÉE POUR LES COULEURS DES LIGNES
  const getRowClass = (currentQuantity, safetyStock) => {
    // Vérifier que les valeurs existent et sont des nombres
    const qty = parseFloat(currentQuantity);
    const safety = parseFloat(safetyStock);
    
    if (isNaN(qty) || isNaN(safety) || safety <= 0) {
      return ""; // Pas de couleur si pas de stock de sécurité défini
    }
    
    console.log(`Comparaison: Quantité=${qty}, Sécurité=${safety}, 2xSécurité=${safety*2}`);
    
    if (qty <= safety) {
      console.log("→ APPLIQUE ROUGE (stock ≤ sécurité)");
      return "stock-critical-row";
    } else if (qty <= safety * 2) {
      console.log("→ APPLIQUE ORANGE (stock ≤ 2×sécurité)");
      return "stock-warning-row";
    }
    
    return "";
  };

  // Filtrer les données
  useEffect(() => {
    let filtered = [...stockData];

    if (filters.location) {
      filtered = filtered.filter(item => {
        const locationInfo = getLocationInfo(item.localisation);
        return locationInfo.name === filters.location;
      });
    }

    if (filters.ingredient) {
      filtered = filtered.filter(item => {
        const ingredientInfo = findIngredientInfo(item.ingredient);
        return ingredientInfo.name.toLowerCase().includes(filters.ingredient.toLowerCase());
      });
    }

    if (filters.search) {
      filtered = filtered.filter(item => {
        const ingredientInfo = findIngredientInfo(item.ingredient);
        const locationInfo = getLocationInfo(item.localisation);
        
        return (
          ingredientInfo.name.toLowerCase().includes(filters.search.toLowerCase()) ||
          ingredientInfo.family.toLowerCase().includes(filters.search.toLowerCase()) ||
          locationInfo.name.toLowerCase().includes(filters.search.toLowerCase()) ||
          item.quantityUnit.toLowerCase().includes(filters.search.toLowerCase())
        );
      });
    }

    setFilteredData(filtered);
  }, [filters, stockData]);

  const getLocationInfo = (locationData) => {
    if (!locationData) return { name: "Non spécifiée", isValid: false };
    
    if (locationData.name && !locationData.name.includes('Localisation-')) {
      return { name: locationData.name, isValid: true };
    }
    
    let locationId;
    if (locationData._id) {
      locationId = locationData._id.toString();
    } else if (typeof locationData === 'string') {
      locationId = locationData;
    }
    
    if (locationId) {
      const foundLocation = locations.find(loc => 
        loc._id && loc._id.toString() === locationId
      );
      
      if (foundLocation && foundLocation.name) {
        return { name: foundLocation.name, isValid: true };
      }
    }
    
    return { name: "Localisation inconnue", isValid: false };
  };

  const findIngredientInfo = (ingredient) => {
    if (!ingredient) return { name: "Non associé", family: "N/A", isValid: false };
    
    const ingredientId = ingredient._id || ingredient;
    const searchId = typeof ingredientId === 'string' ? ingredientId : ingredientId.toString();
    
    if (ingredient.name && ingredient.name !== `Ingrédient-${searchId.slice(-6)}`) {
      const familyName = findIngredientFamily(searchId);
      return { name: ingredient.name, family: familyName, isValid: true };
    }
    
    for (const family of familiesData) {
      if (family.ingredients && Array.isArray(family.ingredients)) {
        const foundIngredient = family.ingredients.find(
          ing => {
            const ingId = ing._id ? ing._id.toString() : null;
            return ingId === searchId;
          }
        );
        if (foundIngredient) {
          return { name: foundIngredient.name, family: family.name, isValid: true };
        }
      }
    }
    
    return { name: `Ingrédient-${searchId.slice(-6)}`, family: "Famille non trouvée", isValid: false };
  };

  const findIngredientFamily = (ingredientId) => {
    if (!ingredientId) return "Famille inconnue";
    
    const searchId = typeof ingredientId === 'string' ? ingredientId : ingredientId.toString();
    
    for (const family of familiesData) {
      if (family.ingredients) {
        const foundIngredient = family.ingredients.find(
          ing => {
            const ingId = ing._id ? ing._id.toString() : null;
            return ingId === searchId;
          }
        );
        if (foundIngredient) {
          return family.name;
        }
      }
    }
    return "Famille non trouvée";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch {
      return "Date invalide";
    }
  };

  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({ ...prev, [filterType]: value }));
  };

  const clearFilters = () => {
    setFilters({ location: "", ingredient: "", search: "" });
  };

  const uniqueIngredients = [...new Set(
    stockData.map(item => findIngredientInfo(item.ingredient).name).filter(name => name && name !== "Non associé")
  )].sort();

  const uniqueLocations = [...new Set(
    stockData.map(item => getLocationInfo(item.localisation).name).filter(name => name && name !== "Non spécifiée")
  )].sort();

  if (loading) {
    return (
      <div className="stock-container">
        <div className="loading-container">
          <span className="loading-icon">📦</span>
          <div className="loading-text">Chargement du stock...</div>
        </div>
      </div>
    );
  }

  const stats = {
    total: stockData.length,
    filtered: filteredData.length
  };

  const hasActiveFilters = filters.location || filters.ingredient || filters.search;

  return (
    <div className="stock-container">
      <div className="stock-header">
        <h1 className="stock-title">État du Stock</h1>
        <p className="stock-subtitle">Vue d'ensemble complète de votre inventaire</p>
        <div className="permission-notice">
          <span className="permission-icon">✏️</span>
          <span>Vous pouvez modifier les stocks de sécurité en cliquant dessus</span>
        </div>
      </div>
      
      <div className="filters-container">
        <div className="filters-header">
          <h3 className="filters-title">Filtres</h3>
          {hasActiveFilters && (
            <button className="clear-filters-btn" onClick={clearFilters}>
              Effacer les filtres
            </button>
          )}
        </div>
        
        <div className="filters-grid">
          <div className="filter-group">
            <label className="filter-label">Recherche</label>
            <input
              type="text"
              className="filter-input"
              placeholder="Rechercher un ingrédient, famille, localisation..."
              value={filters.search}
              onChange={(e) => handleFilterChange('search', e.target.value)}
            />
          </div>

          <div className="filter-group">
            <label className="filter-label">Localisation</label>
            <select
              className="filter-select"
              value={filters.location}
              onChange={(e) => handleFilterChange('location', e.target.value)}
            >
              <option value="">Toutes les localisations</option>
              {uniqueLocations.map(location => (
                <option key={location} value={location}>{location}</option>
              ))}
            </select>
          </div>

          <div className="filter-group">
            <label className="filter-label">Ingrédient</label>
            <select
              className="filter-select"
              value={filters.ingredient}
              onChange={(e) => handleFilterChange('ingredient', e.target.value)}
            >
              <option value="">Tous les ingrédients</option>
              {uniqueIngredients.map(ingredient => (
                <option key={ingredient} value={ingredient}>{ingredient}</option>
              ))}
            </select>
          </div>
        </div>

        {hasActiveFilters && (
          <div className="filter-indicator">
            <span className="filter-count">
              {filteredData.length} résultat(s) sur {stats.total}
            </span>
          </div>
        )}
      </div>
      
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-number">{stats.total}</div>
          <div className="stat-label">Articles en Stock</div>
        </div>

        <div className="stat-card">
          <div className="stat-number" style={{ color: '#27ae60' }}>
            {filteredData.length}
          </div>
          <div className="stat-label">Résultats affichés</div>
        </div>
      </div>

      <div className="stock-table-container">
        <table className="stock-table">
          <thead>
            <tr>
              <th>Famille</th>
              <th>Ingrédient</th>
              <th>Quantité</th>
              <th>Unité</th>
              <th>Prix Unitaire</th>
              <th>Valeur</th>
              <th>Localisation</th>
              <th>Date d'entrée</th>
              <th>Stock de sécurité</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item) => {
                const totalValue = (item.totalQuantity || 0) * (item.averagePrice || 0);
                const ingredientInfo = findIngredientInfo(item.ingredient);
                const locationInfo = getLocationInfo(item.localisation);
                
                // ICI : Appeler la fonction corrigée
                const rowClass = getRowClass(item.totalQuantity, item.safetyStock || 0);
                
                return (
                  <tr key={item._id} className={rowClass}>
                    <td className="family-column">{ingredientInfo.family}</td>
                    <td className="ingredient-column">
                      {ingredientInfo.name}
                      {!ingredientInfo.isValid && (
                        <div className="ingredient-id">
                          ID: {(item.ingredient?._id || item.ingredient)?.toString().slice(-8)}
                        </div>
                      )}
                    </td>
                    <td className="quantity-column">{item.totalQuantity?.toFixed(2)}</td>
                    <td className="unit-column">{item.quantityUnit}</td>
                    <td className="price-column">{item.averagePrice?.toFixed(2)} DT</td>
                    <td className="value-column">{totalValue.toFixed(2)} DT</td>
                    <td className="location-column">{locationInfo.name}</td>
                    <td className="date-column">{formatDate(item.lastUpdated)}</td>
                    <td className="safety-stock-column">
                      {editingId === item._id ? (
                        <div className="safety-stock-edit">
                          <input
                            type="number"
                            min="0"
                            step="0.01"
                            value={editValue}
                            onChange={(e) => setEditValue(e.target.value)}
                            className="safety-stock-input"
                            autoFocus
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                const ingredientId = item.ingredient?._id || item.ingredient;
                                const locationId = item.localisation?._id || item.localisation;
                                updateSafetyStock(ingredientId, locationId, item._id, editValue);
                              }
                              if (e.key === 'Escape') {
                                setEditingId(null);
                                setEditValue("");
                              }
                            }}
                            placeholder="0.00"
                          />
                          <button
                            onClick={() => {
                              const ingredientId = item.ingredient?._id || item.ingredient;
                              const locationId = item.localisation?._id || item.localisation;
                              updateSafetyStock(ingredientId, locationId, item._id, editValue);
                            }}
                            className="safety-stock-save-btn"
                          >
                            ✓
                          </button>
                          <button
                            onClick={() => {
                              setEditingId(null);
                              setEditValue("");
                            }}
                            className="safety-stock-cancel-btn"
                          >
                            ✕
                          </button>
                        </div>
                      ) : (
                        <div 
                          className="safety-stock-display"
                          onClick={() => {
                            setEditingId(item._id);
                            setEditValue(item.safetyStock?.toString() || "0");
                          }}
                        >
                          <span className="safety-stock-value">
                            {(item.safetyStock || 0).toFixed(2)}
                          </span>
                          <span className="edit-icon">✏️</span>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="9" className="empty-state">
                  {hasActiveFilters ? 
                    "Aucun résultat trouvé avec les filtres actuels" : 
                    "Aucune donnée de stock disponible"
                  }
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="color-legend">
        <div className="legend-title">Légende des couleurs :</div>
        <div className="legend-items">
          <div className="legend-item">
            <div className="legend-color legend-critical"></div>
            <span>Stock ≤ Stock de sécurité (Risque de rupture)</span>
          </div>
          <div className="legend-item">
            <div className="legend-color legend-warning"></div>
            <span>Stock ≤ 2 × Stock de sécurité (Attention)</span>
          </div>
          <div className="legend-item">
            <div className="legend-color legend-normal"></div>
            <span>Stock normal</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockReport;